import { useContext, useState } from "react";
import { getDataFromStorage } from "../../util";
import AlertContext from "../../context/AlertContext";
import { useSandpack } from "@codesandbox/sandpack-react";
import useS3FileManagement from "../useS3FileManagement";

export default function SandPackRunBtnHooks() {
  const Alert = useContext(AlertContext);

  const { sandpack } = useSandpack();

  const { onUploadS3Object, getFileDataByfolder, deleteS3Objects } =
    useS3FileManagement();

  const [refreshKey, setRefreshKey] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [consoleMessages, setConsoleMessages] = useState([]);
  const [previewLoaded, setPreviewLoaded] = useState(true);

  const validateImageExtension = (file) => {
    let allowedExtensions = ["jpg", "jpeg", "png", "gif"];
    let extension = file.name.split(".").pop().toLowerCase();

    return allowedExtensions.indexOf(extension) !== -1;
  };

  const convertIntoSandpackFiles = (files) => {
    return files.reduce((acc, cur) => {
      acc[`/${cur.filename}`] = {
        code: cur.fileContents,
      };
      return acc;
    }, {});
  };

  const refreshIframe = async () => {
    setConsoleMessages([]);
    // setRefreshKey((prevKey) => prevKey + 1);
    setPreviewLoaded(false);

    const learnerId = getDataFromStorage("learnerid");

    const s3Object = await getFileDataByfolder(
      Alert.isAdmin && Alert.isqueReport
        ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Alert.selectque.id}/`
        : Alert.isAdmin
        ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}/`
        : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}/`,
      "HOST"
    );
    const files = convertIntoSandpackFiles(s3Object);

    if (Object.keys(files ?? {}).length)
      await deleteS3Objects(
        Object.keys(files).map((file) =>
          Alert.isAdmin && Alert.isqueReport
            ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Alert.selectque.id}${file}`
            : Alert.isAdmin
            ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}${file}`
            : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}${file}`
        ),
        "HOST"
      );

    Alert.setSandpackFiles(sandpack.files);

    for (let file in Alert.sandpackFiles) {
      const isImage = validateImageExtension({ name: file });

      let extraParams = {};
      let code = sandpack.files[file].code;

      if (isImage) {
        extraParams.ContentEncoding = "base64";

        let base64Data = code
          .replace(/^data:application\/octet-stream;base64,/, "")
          .replace(/^data:image\/jpeg;base64,/, "")
          .replace(/^data:image\/jpg;base64,/, "")
          .replace(/^data:image\/png;base64,/, "");

        code = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0));
      }

      try {
        await onUploadS3Object(
          Alert.isAdmin && Alert.isqueReport
            ? `${process.env.REACT_APP_WEBSITE_HOST}/library/${Alert.selectque.id}${file}`
            : Alert.isAdmin
            ? `${process.env.REACT_APP_WEBSITE_HOST}/admin/${learnerId}${file}`
            : `${process.env.REACT_APP_WEBSITE_HOST}/learner/${learnerId}${file}`,
          new Blob([code], { type:file.split(".")[1] }),

          file.split(".")[1],
          "HOST",
          "PUT"
        );
      } catch (error) {
        console.error("Error uploading file to S3:", error);
      }
    }

    Alert.setSandpackFiles(sandpack.files);

    const baseURL = `https://gradiouslmsapp.s3.ap-south-1.amazonaws.com/${process.env.REACT_APP_WEBSITE_HOST}`;

    const previewUrl =
      Alert.isAdmin && Alert.isqueReport
        ? `${baseURL}/library/${Alert.selectque.id}/index.html`
        : Alert.isAdmin
        ? `${baseURL}/admin/${learnerId}/index.html`
        : `${baseURL}/learner/${learnerId}/index.html`;
    console.log("previewUrl:",previewUrl);
    const timeStamp = new Date()
    setPreviewUrl(previewUrl+`?timeStamp=${timeStamp}`);
    setRefreshKey(previewUrl+`?timeStamp=${timeStamp}`);
    setPreviewLoaded(true);
  };

  return {
    refreshKey,
    previewUrl,
    setPreviewUrl,
    setRefreshKey,
    refreshIframe,
    consoleMessages,
    setConsoleMessages,
    validateImageExtension,
    previewLoaded,
    setPreviewLoaded
  };
}
